import styled from "styled-components";

export const DealerContainer = styled.div`
  padding: 32px 0;
  .item {
    background-color: #dce5e5;
    margin: 16px 0;
    border-radius: 10px;
    cursor: pointer;
    padding: 16px;
    .text,
    .province-city {
      font-weight: bold;
    }
    &:hover {
      background-color: #221C35;
      h5 {
        color: #fff;
      }
      color: #fff;
    }
  }
  .not-allowed {
    cursor: not-allowed;
    opacity: 0.5;
    &:hover {
      background-color: #dce5e5;
      h5 {
        color: ${({ theme }) => theme.colors.font};
      }
      color: ${({ theme }) => theme.colors.font};
    }
  }
  .selected {
    background-color: #221C35;
    h5 {
      color: #fff;
    }
    cursor: default;
    color: #fff;
  }
  .buttons {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }
`;
